import { getChannelSlug } from "../utils/getChannelSlug";
import { parseBooleanEnv } from "../utils/parseBooleanEnv";

export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const DEBUG_TOOLS_ENABLED = parseBooleanEnv(process.env.REACT_APP_DEBUG_TOOLS);
export const USER_ID = "user_id";
export const DEFAULT_AGENT_NAME = "AI Assistant";
export const DEFAULT_OPERATOR_LABEL = "Operator";

export const DEFAULT_MAIN_COLOR = "#E23A00";

export const CHAT_CHANNEL = getChannelSlug() || "wackerparts";
